import { render, staticRenderFns } from "./EpicAssignments.vue?vue&type=template&id=019ef644&"
import script from "./EpicAssignments.vue?vue&type=script&lang=js&"
export * from "./EpicAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports